import Model from 'flarum/common/Model';

/** What crowd moderation did to a report's post. */

export class Queue extends Model {
  name = Model.attribute('name');
  description = Model.attribute('description');
  color = Model.attribute('color');
  position = Model.attribute('position');
  isRestricted = Model.attribute('isRestricted');
  crowdThreshold = Model.attribute('crowdThreshold');
  groups = Model.hasMany('groups');
}

/** Where a post is: its discussion's slug and title, and the post's number. */

export class Entry extends Model {
  type = Model.attribute('type');
  reason = Model.attribute('reason');
  reasonDetail = Model.attribute('reasonDetail');
  createdAt = Model.attribute('createdAt', Model.transformDate);
  reportStatus = Model.attribute('reportStatus');
  outcome = Model.attribute('outcome');
  user = Model.hasOne('user');
  place = Model.attribute('post');
  /** Staff listing a member's reports only: the report, and how it really went. */
  reportId = Model.attribute('reportId');
  verdict = Model.attribute('verdict');
}

/** How a report really went: its status, or restored when staff put back what the crowd hid. */

/** A member's record over one time frame: see ReporterStats. */

export class ReportEvent extends Model {
  type = Model.attribute('type');
  /** The `data` attribute: `data` itself is the model's resource object. */
  details = Model.attribute('data');
  body = Model.attribute('body');
  createdAt = Model.attribute('createdAt', Model.transformDate);
  user = Model.hasOne('user');
}
export class Report extends Model {
  status = Model.attribute('status');
  outcome = Model.attribute('outcome');
  reportersNotified = Model.attribute('reportersNotified');
  entryCount = Model.attribute('entryCount');
  place = Model.attribute('discussion');
  createdAt = Model.attribute('createdAt', Model.transformDate);
  updatedAt = Model.attribute('updatedAt', Model.transformDate);
  closedAt = Model.attribute('closedAt', Model.transformDate);
  canAssignOthers = Model.attribute('canAssignOthers');
  crowdState = Model.attribute('crowdState');
  post = Model.hasOne('post');
  user = Model.hasOne('user');
  assignee = Model.hasOne('assignee');
  queue = Model.hasOne('queue');
  closedBy = Model.hasOne('closedBy');
  entries = Model.hasMany('entries');
  events = Model.hasMany('events');
  isActive() {
    return this.status() === 'open' || this.status() === 'in_progress';
  }

  /** The crowd hid the post (or sent it to approval) and staff haven't undone it. */
  crowdActed() {
    const state = this.crowdState();
    return state === 'hidden' || state === 'approval';
  }
}
export class Rule extends Model {
  name = Model.attribute('name');
  position = Model.attribute('position');
  isEnabled = Model.attribute('isEnabled');
  conditions = Model.attribute('conditions');
  queue = Model.hasOne('queue');
  assignee = Model.hasOne('assignee');
  assigneeGroup = Model.hasOne('assigneeGroup');
}
flarum.reg.add('ernestdefoe-docket', 'common/models', { Queue: Queue,Entry: Entry,ReportEvent: ReportEvent,Report: Report,Rule: Rule, });